import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { LegalPage } from './LegalPage';
const sections = [{
  title: 'Introduction',
  content: '888 Sourcing Limited ("we", "us", "our") is committed to protecting your privacy and complying with UK and EU data protection laws, including the UK GDPR and the Data Protection Act 2018. This Privacy Policy explains how we collect, use, and protect personal data when you interact with our website and services.'
}, {
  title: 'Information We Collect',
  content: ['We may collect the following personal information when you use our website or contact us:', '• Name, job title, and company details', '• Email address, phone number, and postal address', '• Website usage data (e.g., pages visited, time spent, IP address)', '• Any information you provide in inquiries or correspondence']
}, {
  title: 'How We Use Your Data',
  content: ['Your personal data is used for purposes including:', '• Responding to inquiries and providing our services', '• Managing business relationships with manufacturers, retailers, and distributors', '• Sending relevant communications or updates (you may opt-out at any time)', '• Improving our website and services']
}, {
  title: 'Data Sharing and Transfers',
  content: 'We do not sell or rent your personal information. We may share data with trusted third-party service providers who support our business operations, such as IT, payment processing, or logistics partners. Any international transfers comply with applicable UK and EU data protection laws.'
}, {
  title: 'Data Security',
  content: 'We implement appropriate technical and organizational measures to protect personal data against unauthorized access, loss, or misuse.'
}, {
  title: 'Your Rights',
  content: ['You have the right to:', '• Access and receive a copy of your personal data', '• Correct any inaccuracies in your data', '• Request erasure of your data', '• Restrict or object to processing', '• Withdraw consent at any time where processing is based on consent']
}, {
  title: 'Cookies and Tracking',
  content: 'Our website may use cookies to enhance user experience, analyze traffic, and provide personalized content. You can manage or disable cookies via your browser settings.'
}, {
  title: 'Retention of Data',
  content: 'We retain personal data only as long as necessary to fulfill the purposes outlined in this policy or as required by law.'
}, {
  title: 'Changes to this Policy',
  content: 'We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated effective date.'
}];
export function PrivacyPolicyPage() {
  useEffect(() => {
    document.title = 'Privacy Policy | 888 Sourcing Limited';
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-[#0a1628] text-white" data-id="element-656">
      <div className="container mx-auto px-4 py-8" data-id="element-657">
        <div className="flex items-center justify-between mb-8" data-id="element-658">
          <div className="flex items-center space-x-2" data-id="element-659">
            <Link to="/" className="text-blue-400 hover:text-blue-300 transition-colors" data-id="element-660">
              <ArrowLeft className="w-5 h-5" data-id="element-661" />
            </Link>
            <h1 className="text-2xl font-bold" data-id="element-662">Privacy Policy</h1>
          </div>
          <div className="text-sm text-gray-400" data-id="element-663">
            Last updated: January 2024
          </div>
        </div>
        <LegalPage title="Privacy Policy" lastUpdated="January 2024" sections={sections} showContactInfo={true} data-id="element-664" />
      </div>
    </div>;
}